export class PqrMessageEntity {
    
    id: number;
    nameUser: string;
    userId: number;
    customerId: number;
    customerName: string
    creationDate:Date;
    number: string;
    active: boolean;
    ticket: number;

    constructor () {}
}